__turbopack_context__.v({
  "container": "yQy5fq_container",
  "form": "yQy5fq_form",
  "logo": "yQy5fq_logo",
  "rightColumn": "yQy5fq_rightColumn",
});
